"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Icons = _interopRequireWildcard(require("./Icons"));

var CustomIcon = function CustomIcon(_ref) {
  var glyph = _ref.glyph,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["glyph", "className"]);
  var Icon = Icons[glyph];
  var type = Icon === null || Icon === void 0 ? void 0 : Icon.type;
  var viewBox = Icon === null || Icon === void 0 ? void 0 : Icon.props.viewBox;
  if (!Icon) return null;
  return type !== 'svg' ? /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('svg-icon', className),
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: viewBox || '0 0 12 12'
  }), Icon) : /*#__PURE__*/React.createElement(React.Fragment, null, Icon);
};

var _default = CustomIcon;
exports["default"] = _default;
//# sourceMappingURL=CustomIcon.js.map